/**
 * Created by 枯荣<panjiankang@cai-inc.com> on 2019-08-01 11:04.
 */
const BaseCategoryPage = require( 'base/category-page' );
const Server = require( 'helper/server' );
const Pagination = require( 'helper/pagination' );
const { initMenu } = require( 'purchasing-federation/common/config/member-center-menu' );
const Regexp = require( 'helper/regexp' );

const baseInfoTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/base-info' ];
const particpantsTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/particpants-list-tpl' ];
const remittanceTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/remittance-list-tpl' ];
const payinfoformTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/payinfoform' ];
const paymentSnapshotsTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/payment-snapshots' ];
const changeMemberTpl = Handlebars.templates[ 'purchasing-federation/registration-detail/templates/change-member' ];

class RegistrationDetail extends BaseCategoryPage {
  constructor() {
    super( {
      events: {
        'click .submit-remittance': 'submitRemittance',
        'change .upload-controller': 'uploadController',
        'click #submitPayment': 'submitPayment',
        'click .download-cert': 'downloadCert',
        'click .show-payment': 'showPayment',
        'click .edit-payment': 'paymentEdit',
        'click .change-member': 'changeMember',
        'change .select-new-member': 'selectNewMemebr',
        'click .search-btn': 'handleSearch',
        'click .reset-btn': 'resetSearch',
        'click .submit-change': 'submitChange',
        'click .thumbnails': 'showBigImg',
        'click .delete-img': 'delImg'
      }
    } );
    this.$renderRoot = this.$el.find( '.block__content' );
    this.PAGE_SIZE = 10;
    this.PAGE_NO = 1;
    this.initPage();
  }

  async init() {
    const data = initMenu( 'ActivityManage', {}, {} );
    this.$el.find( '.list__nav-title' ).html( data.text );
    this.$el.find( '.treeData[name="tree-data"]' ).html( JSON.stringify( data ) );
    super.init();
  }

  search() {
  }

  showBigImg( e ) {
    const el = e.target || e.srcElement;
    const src = $( el ).attr( 'src' );
    const template = `
      <div class="modal-content">
        <img src="${ src }" alt="">
      </div> `;
    this.$el.find( '#show-big-img #modal-wrap' ).html( template );
    $( '#show-big-img' ).modal( 'show' );
  }

  /**
   * 获取文件大小
   * @param e
   * @returns {string}
   */
  getFileSize( e ) {
    const name = e.target.files[ 0 ].name;
    const size = ( e.target.files[ 0 ].size / 1024 / 1024 ).toFixed( 1 );
    return {
      size,
      name
    };
  }

  /**
   * 初始化页面
   * @returns {Promise<void>}
   */
  async initPage() {
    const { activityId, id: signUpId } = this.query.params || {};
    try {
      const data = await Server.getSignUpDetail( {
        activityId,
        signUpId
      } );
      const { checkInList = [], paymentList, activitySignUp = {} } = data;
      const html = baseInfoTpl( {
        _DATA_: {
          ...data,
          paymentListLength: ( paymentList || [] ).length
        }
      } );
      const particpantsHtml = particpantsTpl( { _DATA_: checkInList } );
      const remittanceHtml = remittanceTpl( {
        _DATA_: paymentList,
        ApplyStatus: activitySignUp.applyStatus
      } );
      this.$renderRoot.html( html );
      this.$renderRoot.find( '.participants-list .table-wrap' ).append( particpantsHtml );
      this.$renderRoot.find( '.remittance-detail .table-wrap ' ).append( remittanceHtml );
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }

  /**
   * 查看凭证
   * @param e
   * @returns {Promise<void>}
   */
  async showPayment( e ) {
    const el = e.target || e.srcElement;
    const data = $( el ).data( 'value' );
    // const data = await Server.showPayment( { paymentId } );
    const html = paymentSnapshotsTpl( { _DATA_: data || [] } );
    $( '#submit-remittance-modal' ).find( '#modal-wrap' ).html( html );
    $( '#submit-remittance-modal' ).modal( 'show' );
  }

  /**
   * 下载证书
   * @param e
   */
  downloadCert( e ) {
    const el = e.target || e.srcElement;
    const { personId } = $( el ).data();
    const activityId = $( '.activityId' ).val();
    window.open( `${ Server.urls.downloadCert }?personId=${ personId }&activityId=${ activityId }` );
  }

  /**
   * 渲染汇款信息弹框
   * @param data
   */
  renderPaymentInfo( data = {} ) {
    const html = payinfoformTpl( { _DATA_: data } );
    $( '#submit-remittance-modal' ).find( '#modal-wrap' ).html( html );
    const $form = this.$el.find( '#upload-form' );
    const paymentSnapshots = data.paymentSnapshots || [];
    this.renderPaymentSnapshot( $form, paymentSnapshots, 'init' );
    $( '#submit-remittance-modal' ).modal( 'show' );
  }

  /**
   * 提交汇款信息按钮
   */
  submitRemittance() {
    const { id: signUpId } = this.query.params || {};
    this.renderPaymentInfo( { signUpId } );
  }

  /**
   * 编辑汇款信息按钮
   * @param e
   * @returns {Promise<void>}
   */
  async paymentEdit( e ) {
    const el = e.target || e.srcElement;
    const data = $( el ).data( 'value' );
    // const data = await Server.getPaymentDetail( { paymentId } );
    this.renderPaymentInfo( data );

  }

  /**
   * 跟换人员按钮
   * @returns {Promise<void>}
   */
  async changeMember( e ) {
    const el = e.target || e.srcElement;
    const id = $( el ).data( 'id' );
    await this.renderChangeMemberList( '.change-member-table-wrap', id );
    $( '#change—member-modal' ).modal( 'show' );
  }

  /**
   * 渲染更换人员弹框
   * @param $root
   * @param requestParams
   * @returns {Promise<void>}
   */
  async renderChangeMemberList( $root, id, requestParams = {} ) {
    // const { data, total } = {
    //   data: [ {}, {}, {} ],
    //   total: 100
    // };
    const data = await Server.getStaffList( requestParams );
    const html = changeMemberTpl( {
      _DATA_: data,
      _ID_: id
      // _TOTAL_: total,
      // _pageSize_: this.PAGE_SIZE
    } );
    $( $root ).html( html );
    // $( $root ).find( '.total' ).text( total || 0 );
    // const args = [ '#change—member-modal', total, 'PAGE_SIZE', 'PAGE_NO', 'modalSearch' ];
    // Pagination.init.apply( this, args );
  }

  /**
   * 更换人员搜索重置
   */
  resetSearch() {
    this.PAGE_NO = 1;
    this.PAGE_SIZE = 10;
    $( '#change—member-modal' ).find( 'form' )[ 0 ].reset();
    this.modalSearch();
  }

  handleSearch() {
    this.modalSearch();
  }

  /**
   * 更换人员搜索
   */
  modalSearch() {
    const $form = $( '#change—member-modal' ).find( 'form' );
    const name = $form.find( 'input[name="name"]' ).val();
    const mobile = $form.find( 'input[name="mobile"]' ).val();
    const id = $( '.change-member-table' ).data( 'id' );
    const requestParams = {
      name,
      mobile
    };
    this.renderChangeMemberList( '.change-member-table-wrap', id, requestParams );
  }

  /**
   * 选择新人员
   * @param e
   */
  selectNewMemebr( e ) {
    const el = e.target || e.srcElement;
    $( '.select-new-member' ).not( el ).attr( 'checked', false );
  }

  /**
   * 更换人员确定
   * @returns {boolean}
   */
  submitChange() {
    const len = $( '.select-new-member:checked' ).length;
    if (len === 0) {
      alert( '请选择新的报名人' );
      return false;
    }
    const targetId = this.$el.find( '.change-member-table' ).data( 'id' );
    const select = $( '.select-new-member:checked' ).data( 'value' );
    const payload = {
      ...select,
      headImageUrl: select.headPhotoUrl,
      id: targetId
    };
    Server.exchangeSignUpStaff( payload ).then( res => {
      if (res) {
        this.initPage();
      }
      $( '#change—member-modal' ).modal( 'hide' );
    }, () => {
      alert( '切换失败' );
    } );
  }

  /**
   *
   * @param e
   * @returns {boolean}
   */
  uploadController( e ) {
    const $form = this.$el.find( '#upload-form' );
    const { size, name } = this.getFileSize( e );
    const fileName = name.substr( name.lastIndexOf( '.' ) ).toUpperCase();
    if (fileName !== '.PNG' && fileName != '.JPG' && fileName !== '.JPEG') {
      alert( '图片限于png,jpeg,jpg格式' );
      $form[ 0 ].reset();
      return false;
    }
    if (size > 5) {
      alert( '附件过大，无法上传成功, 请重新上传' );
      $form[ 0 ].reset();
      return false;
    }
    $form.ajaxSubmit( {
      type: 'post',
      url: Server.urls.upload,
      contentType: 'application/json',
      dataType: 'json',
      iframeTarget: '#myFrame',
      success: ( data ) => {
        $form[ 0 ].reset();
        this.renderPaymentSnapshot( $form, data, 'upload' );
      },
      error: ( msg ) => {
        $form[ 0 ].reset();
        alert( msg.responseText || '未知错误' );
      }
    } );
  }

  /**
   * 渲染汇款凭证
   * @param root 根节点
   * @param data 源数据
   * @param type 类型， 当type === 'upload' 时，图片插入上传框之前
   */
  renderPaymentSnapshot( root, data, type ) {
    const $preview = root.find( '.upload-certificate' );
    let html = '';
    if (_.isArray( data )) {
      $.map( data, ( item ) => {
        html += this.genImg( item );
      } );
    } else {
      html = this.genImg( data );
    }
    if (html) {
      if (type === 'upload') {
        $preview.find( '.upload-certificate-upload  ' ).before( html );
      } else {
        $preview.prepend( html );
      }
    }
  }

  genImg( item ) {
    const { url, type = '', original = '' } = item;
    if (url) {
      const html = `
        <div class="upload-certificate-preview upload-certificate-item">
          <div class="img-mask">
            <span class="delete-img"><i class="icon iconfont icon-Shape"></i></span>
          </div>
          <img src="${ url }" alt="" data-suffix="${ type }" data-name="${ original }">
        </div>`;
      return html;
    }
  }

  async submitPayment() {
    const $form = this.$el.find( '#upload-form' );
    const $root = this.$el.find( '.form-root' );
    let errMsg;
    const $preview = $form.find( '.upload-certificate-preview' );
    // 汇款户名
    const accountName = $root.find( '#accountName' ).val();
    // 汇款银行
    const bankName = $root.find( '#bankName' ).val();
    // 汇款银行账号
    const bankAccount = $root.find( '#bankAccount' ).val();
    // 汇款金额
    const amount = $root.find( '#amount' ).val();
    // 活动报名id
    const signUpId = $( 'input[name="signUpId"]' ).val();
    // 汇款id
    const id = $( 'input[name="id"]' ).val();
    // 汇款凭证
    if (!Regexp.bankCardNo.test( bankAccount ) && !errMsg) {
      errMsg = '请输入正确的汇款银行账号';
    }
    if (isNaN( amount ) && !errMsg) {
      errMsg = '请输入正确的汇款金额';
    }
    if (errMsg) {
      alert( errMsg );
      return false;
    }
    const paymentSnapshots = [];
    $.map( $preview, ( item, index ) => {
      const imgs = $( item ).find( 'img' );
      const url = imgs.attr( 'src' ).replace( '?x-oss-process=image/quality,Q_75', '' );
      const { suffix, name } = imgs.data();
      paymentSnapshots.push( {
        suffix,
        url,
        sort: index + 1,
        name
      } );
    } );
    if (!paymentSnapshots.length) {
      alert( '请上传的汇款凭证' );
      return false;
    }

    const payload = {
      accountName,
      bankName,
      bankAccount,
      amount,
      signUpId,
      id,
      paymentSnapshots
    };
    try {
      const res = await Server.submitPayment( payload );
      if (res) {
        $( '#submit-remittance-modal' ).modal( 'hide' );
        ZCY.utils.modal( {
          type: 'success',
          button: [ '确定' ],
          container: $( '.purchasing-registration-detail' ),
          content: [ '保存成功' ]
        } );
        this.initPage();
      }
    }
    catch ( e ) {
      alert( e.responseText || '未知错误' );
    }
  }

  delImg( e ) {
    const $wrap = this.$el.find( '#upload-form' ).find( '.upload-certificate' );
    const el = e.target || e.srcElement;
    $( el ).parents( '.upload-certificate-preview' ).remove();
    const $preview = $wrap.find( '.upload-certificate-preview' );
    if ($preview.length < 5) {
      $wrap.find( '.upload-certificate-upload' ).show();
    }
  }

}

module.exports = RegistrationDetail;
